import {Injectable} from '@angular/core';
import {Router, ActivatedRoute, NavigationEnd, ActivatedRouteSnapshot, NavigationStart} from '@angular/router';

@Injectable()
export class ActiveStateService {

  public snapshot: ActivatedRouteSnapshot = null;

  constructor(router: Router, route: ActivatedRoute) {
    router.events.subscribe(event => {
      if (event instanceof NavigationStart) {

        // Traverse the active route tree
        let snapshot = route.snapshot;
        let activated = route.firstChild;
        if (activated != null) {
          while (activated != null) {
            snapshot = activated.snapshot;
            activated = activated.firstChild;
          }
        }
        // Try finding the 'stateName' from the data
        this.snapshot = snapshot;
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/service/ActivateStateService.ts